import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { IRazorPayHashRequest, IRazorPayHashResponse } from './models';

const TAG = ApiTags.Payment;

const razorPayApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getRazorPayHash: builder.mutation<IRazorPayHashResponse, IRazorPayHashRequest>({
      query: (model) => ({
        url: '/Payments/RazorPay',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    })
  })
})

export const {
  useGetRazorPayHashMutation
} = razorPayApi;